/**
 * Default slot multiplier roster for the 8-row Plinko demo. Length 9
 * (one per slot). High at the edges (rare landings, big payouts), low
 * in the centre (common landings, sub-1× returns).
 *
 * <p>Calibration: with binomial probability for an 8-row walk, the
 * centre slot 4 catches the ball ~27.3% of the time. Total expected
 * value per drop ≈ 0.99× the bet — small house edge, kept in the centre
 * slot weight.
 */
export const DEFAULT_PLINKO_MULTIPLIERS: readonly number[] = [
  10,
  3,
  1.5,
  0.7,
  0.4,
  0.7,
  1.5,
  3,
  10,
];
